import type { PublicApiKey } from '#packages/apilib';
import type { createPanelManagerApi } from './panelManagerApi';

export const PanelManagerApiKey: PublicApiKey<typeof createPanelManagerApi> = {
  name: 'PanelManagerApi',
  public: true,
};
